import React, { useContext, useEffect, useState } from "react";
import Modal from "react-bootstrap/Modal";
import { Context } from "../../../../utils/context";
import { getData } from "../../../../utils/api";

import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation } from "swiper/modules";

import "swiper/css";
import "swiper/css/navigation";
import "./DamageImages.css";

const DamageImages = ({ show, onHide, complaintID }) => {
  const { IMG_URL } = useContext(Context);
  const [data, setData] = useState([]);

  const getAllProductData = async () => {
    const res = await getData(
      `/complaint-management/complaints/all-damage-images/${complaintID}`,
    );
    setData(res?.data || []);
  };

  useEffect(() => {
    if (complaintID) {
      getAllProductData();
    }
  }, [complaintID]);

  return (
    <Modal
      className="common_modal Service_History_modal"
      centered
      show={show}
      onHide={onHide}
      size="lg">
      <Modal.Header closeButton>
        <Modal.Title>Damage Product Images</Modal.Title>
      </Modal.Header>

      <Modal.Body>
        {data.length > 0 ? (
          <Swiper
            modules={[Navigation]}
            navigation
            spaceBetween={20}
            slidesPerView={2}
            style={{ height: "420px" }}>
            {data.map((item, index) => (
              <SwiperSlide key={index}>
                <div style={{ textAlign: "center" }}>
                  <img
                    src={`${IMG_URL}/${item.image}`}
                    alt="Damage"
                    style={{
                      maxHeight: "400px",
                      maxWidth: "100%",
                      objectFit: "contain",
                    }}
                  />
                </div>
              </SwiperSlide>
            ))}
          </Swiper>
        ) : (
          <p style={{ textAlign: "center" }}>No images available</p>
        )}
      </Modal.Body>
    </Modal>
  );
};

export default DamageImages;
